import moment from 'moment'
import React from 'react'
import { NEWS_DATE } from '../../constants/formats'
import { DayDivider, Title } from '../pages/NewsPage'

interface Props {
  date: string
  title: string
}

export default class NewsItem extends React.Component<Props> {
  render() {
    const { date, title } = this.props
    return (
      <React.Fragment>
        <DayDivider>{moment(date, 'YYYY-M-D').format(NEWS_DATE)}</DayDivider>
        <article className={`news-${date}`}>
          <Title>{title}</Title>
        </article>
        {this.props.children}
      </React.Fragment>
    )
  }
}
